<template>
  <div class="container-fluid nav-bar">
    <div class="container">
      <nav class="navbar navbar-light navbar-expand-lg py-4">
        <router-link to="/" class="navbar-brand text-primary fw-bold">
          <img src="/img/logo-nav.png" alt="Khaing Parami Japanese Language Center" class="navbar-logo" />
        </router-link>

        <button
          class="navbar-toggler py-2 px-3"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
        >
          <span class="fa fa-bars text-primary"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarCollapse">
          <div class="navbar-nav mx-auto">
            <router-link
              @click="closeNavbar()"
              to="/"
              class="nav-item nav-link"
              active-class="active"
              exact-active-class="active"
              @click.native="closeNavbar"
              >{{ $t("home") }}</router-link
            >
            <div class="nav-item dropdown">
              <a
                href=""
                class="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                active-class="active"
                >{{ $t("aboutSchool") }}</a
              >
              <div class="dropdown-menu bg-light">
                <router-link
                  to="/school-history"
                  class="dropdown-item"
                  @click.native="closeNavbar"
                  >{{ $t("schoolHistory") }}</router-link
                >
                <router-link
                  to="/greeting-of-principle"
                  class="dropdown-item"
                  @click.native="closeNavbar"
                  >{{ $t("greetingOfPrinciple") }}</router-link
                >
              </div>
            </div>
            <div class="nav-item dropdown">
              <a
                href=""
                class="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                active-class="active"
                >{{ $t("courses") }}</a
              >
              <div class="dropdown-menu bg-light">
                <router-link
                  to="/beginner-course"
                  class="dropdown-item"
                  @click.native="closeNavbar"
                  >{{ $t("beginnerLevel") }}</router-link
                >
                <router-link
                  to="/elementary-course"
                  class="dropdown-item"
                  @click.native="closeNavbar"
                  >{{ $t("elementaryLevel") }}</router-link
                >
                <router-link
                  to="/intermediate-course"
                  class="dropdown-item"
                  @click.native="closeNavbar"
                  >{{ $t("intermediateLevel") }}</router-link
                >
                <router-link
                  to="/upper-intermediate-course"
                  class="dropdown-item"
                  @click.native="closeNavbar"
                  >{{ $t("upperIntermediateLevel") }}</router-link
                >
              </div>
            </div>
            <div class="nav-item dropdown">
              <a
                href=""
                class="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                active-class="active"
                >{{ $t("activities") }}</a
              >
              <div class="dropdown-menu bg-light">
                <router-link
                  to="/gallery-book"
                  class="dropdown-item"
                  @click.native="closeNavbar"
                  >{{ $t("galleryBook") }}</router-link
                >
                <router-link
                  to="/school-and-career-guidance"
                  class="dropdown-item"
                  @click.native="closeNavbar"
                  >School & Career Guidance</router-link
                >
                <router-link
                  to="/student-messages"
                  class="dropdown-item"
                  @click.native="closeNavbar"
                  >Student Messages</router-link
                >
              </div>
            </div>
            <router-link
              to="/blogs"
              class="nav-item nav-link"
              active-class="active"
              exact-active-class="active"
              @click.native="closeNavbar"
              >{{ $t("blogs") }}</router-link
            >
            <router-link
              to="/contact"
              class="nav-item nav-link"
              active-class="active"
              exact-active-class="active"
              @click.native="closeNavbar"
              >{{ $t("contact") }}</router-link
            >
          </div>
          <!-- <button
            class="btn-search btn btn-primary btn-md-square me-4 rounded-circle d-none d-lg-inline-flex"
            data-bs-toggle="modal"
            data-bs-target="#searchModal"
          >
            <i class="fas fa-search"></i>
          </button> -->
          <a class="btn btn-primary btn-sm-square me-2 rounded-circle" href="https://www.facebook.com/profile.php?id=100068847397700&mibextid=ZbWKwL"
            ><i class="fab fa-facebook-f"></i
          ></a>
          <a class="btn btn-primary btn-sm-square me-2 rounded-circle" href="https://www.tiktok.com/@khaingparami30?_t=8rchDSrokUM&_r=1"
            ><i class="fab fa-tiktok"></i></a>

          <div class="nav-item dropdown">
            <a
              href=""
              class="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              ><i class="fas fa-globe" @click="changeLocale('en')"></i>
              {{ currentLanguage }}</a
            >
            <div class="dropdown-menu bg-light text-center">
              <a href="" class="dropdown-item" @click="changeLocale('en')"
                ><img src="/img/us.png" alt="" style="width: 20px" /> EN</a
              >
              <a href="" class="dropdown-item" @click="changeLocale('mm')"
                ><img src="/img/mm.png" alt="" style="width: 20px" /> MM</a
              >
              <a href="" class="dropdown-item" @click="changeLocale('jp')"
                ><img src="/img/jp.png" alt="" style="width: 20px" /> JP</a
              >
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      languages: {
        en: "English",
        mm: "Myanmar",
        jp: "Japanese",
      },
    };
  },
  computed: {
    currentLanguage() {
      return this.languages[this.$i18n.locale];
    },
  },
  methods: {
    changeLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
    },
    closeNavbar() {
      const navbarCollapse = document.getElementById("navbarCollapse");
      const Bootstrap = window.bootstrap;
      if (!navbarCollapse || !Bootstrap) {
        return;
      }
      const collapse = new Bootstrap.Collapse(navbarCollapse, {
        toggle: false,
      });
      collapse.hide();
    },
  },
};
</script>

<style>
.navbar-logo {
  height: 60px;
  width: auto;
  max-width: 100%;
}

@media (max-width: 991.98px) {
  .navbar-logo {
    height: 44px;
  }
}

.nav-link {
  color: #5c1a72;
}
.navbar .dropdown-toggle::after {
  display: none !important;
}
</style>
